module.exports = __webpack_public_path__ + "img/about_us_hero.5b99ddc7.jpg";